// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2l65h","buttons":"SendReceipts_buttons__2of9D","email":"SendReceipts_email__3v5uT","bookApptTitle":"SendReceipts_bookApptTitle__2TpuU"};